import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import "./DashboardPages/DashboardPages.css";
import { useDispatch, useSelector } from "react-redux";
import { Badge } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { fetchUsers } from "../redux/slices/settingSlice";
import { ListReportIssues } from "../components/Header/Data3";
import { toast } from "react-toastify";

const Sidebar = ({ onItemClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedItem, setSelectedItem] = useState(null);
  const [rows, setRows] = useState(null);
  const logUser = localStorage.getItem("USER_ROLE");
  const userinfo = useSelector((state) => state.user.userInfo);
  const islogin = useSelector((state) => state.user.isLogin);
  const user = islogin ? JSON.parse(userinfo) : null;
  const id = user?.Gurudwara;
  const isAdmin = user && user.Role === "admin"; // Check if user is admin
  const { pendingTemps } = useSelector((state) => state.templates);
  const { imageData } = useSelector((state) => state.images);
  const { finalUsers } = useSelector((state) => state.setting);
  const dispatch = useDispatch();

  const isProfileComplete = !!(
    user &&
    user.FirstName &&
    user.LastName &&
    user.Email &&
    user.Phone &&
    user.UserName &&
    user.Radius &&
    user.Location &&
    user.ZipCode
  );
  const caIdPending = finalUsers.filter(
    (user) => user.caId != null && user.caIdStatus == 0
  );

  useEffect(() => {
    if (isAdmin && finalUsers.length === 0) {
      dispatch(fetchUsers());
    }
  }, [isAdmin, finalUsers.length, dispatch]);

  const fetchListReportIssues = async () => {
    const respose = await ListReportIssues();
    setRows(respose);
  };

  useEffect(() => {
    if (isAdmin) {
      fetchListReportIssues();
    }
  }, []);

  console.log(rows, "fetchListReportIssues");

  const filterPending =
    rows && rows?.filter((row) => row.reportStatus == "Pending");

  let pendingImages =
    imageData && imageData.filter((image) => image.image_status == 0);

  const sidebarItems = [
    { id: 1, title: "Dashboard", link: "/dashboardpage" },
    {
      id: 2,
      title: "My Services for Sale",
      link: "/dashboardpage/my-services",
    },
    {
      id: 3,
      title: "Flash Deals",
      link: "/dashboardpage/flash-Deals",
    },
    { id: 4, title: "Calendar", link: "/dashboardpage/calendar" },
    {
      id: 5,
      title: "My Needs/Requests",
      link: "/dashboardpage/needs-requests",
    },
    { id: 6, title: "Orders", link: "/dashboardpage/orders" },
    { id: 7, title: "Inbox", link: "/dashboardpage/inbox" },
    { id: 8, title: "Settings", link: "/dashboardpage/settings" },
    { id: 9, title: "Sponsored Ads", link: "/dashboardpage/sponsored-ads" },
    {
      id: 14,
      title: "Items For Sale",
      link: "/dashboardpage/my-items",
    },
    ...(logUser === "admin"
      ? [
          {
            id: 11,
            title: "User Management",
            link: "/admin/usermanagement",
          },
          {
            id: 12,
            title: "Category Management",
            link: "/admin/categorymanagement",
          },
          {
            id: 13,
            title: "Category Questions",
            link: "/admin/questions",
          },
          // {
          //   id: 26,
          //   title: "Vendor Questions",
          //   link: "/admin/vendor-questions",
          // },
          {
            id: 16,
            title: "Gurdwara Management",
            link: "/dashboardpage/gurdwaramanagement",
          },
          {
            id: 22,
            title: "Gurdwara News",
            link: "/dashboardpage/gurdwaraNews",
          },
          {
            id: 24,
            title: "Report Management",
            link: "/dashboardpage/reportManagement",
          },
        ]
      : []),
    ...(logUser === "provider"
      ? [
          {
            id: 10,
            title: "My Favorites",
            link: "/dashboardpage/myFavorites",
          },
         /* {
            id: 27,
            title: "Customers Initiated",
            link: "/dashboardpage/customerinitiated",
          },*/
        ]
      : []),
    {
      id: 15,
      title: "Notify List",
      link: "/dashboardpage/notifyList",
    },
    ...(!isAdmin && id !== 0
      ? [
          {
            id: 16,
            title: "Gurdwara Management",
            link: "/dashboardpage/gurdwaramanagement",
          },
          {
            id: 21,
            title: "Gurdwara News",
            link: "/dashboardpage/gurdwaraNews",
          },
        ]
      : []),
    {
      id: 17,
      title: "Message Templates",
      link: "/dashboardpage/message-templates",
    },
    ...(logUser !== "customer"
      ? [
          {
            id: 18,
            title: "Media Templates",
            link: "/dashboardpage/media-templates",
          },
          {
            id: 26,
            title: "Auto Schedule Messages",
            link: "/dashboardpage/autoScheduleMessages",
          },
        ]
      : []),
    {
      id: 19,
      title: "Community Discussions",
      link: "/dashboardpage/community-discussions/local-newspapers",
    },
    {
      id: 20,
      title: "Community WebSites",
      link: "/dashboardpage/community-websites",
    },
    {
      id: 25,
      title: "Reports",
      link: "/dashboardpage/reports",
    },
  ];

  const handleItemClick = (item) => {
    if (item.link !== "/dashboardpage/settings" && !isProfileComplete) {
      toast.info("Please complete your profile .");
    }
    setSelectedItem(item);
    navigate(item.link);
  };

  return (
    <div className="side-bar p-3 border-right border-1px-solid-black">
      {sidebarItems.map((item) => (
        <div
          key={item.id}
          className={`sidebar-item py-2 px-3 ${
            (location.pathname === "/dashboardpage" &&
              item.link === "/dashboardpage") ||
            (location.pathname === item.link &&
              item.link !== "/dashboardpage") ||
            (location.pathname.startsWith(item.link + "/") &&
              item.link !== "/dashboardpage")
              ? "selected"
              : ""
          } `}
          onClick={() => handleItemClick(item)}
        >
          {item.title}
          {isAdmin &&
            item.title === "Message Templates" &&
            pendingTemps?.length > 0 && (
              <Badge badgeContent={pendingTemps?.length} color="error">
                .
              </Badge>
            )}
          {isAdmin &&
            item.title === "Media Templates" &&
            pendingImages?.length > 0 && (
              <Badge badgeContent={pendingImages?.length} color="error">
                .
              </Badge>
            )}
          {isAdmin && item.title === "Settings" && caIdPending?.length > 0 && (
            <Badge badgeContent={caIdPending?.length} color="error">
              &nbsp; <span className="invisible">.</span>
            </Badge>
          )}
          {isAdmin &&
            item.title === "Report Management" &&
            rows?.length > 0 && (
              <Badge badgeContent={filterPending?.length} color="error">
                &nbsp; <span className="invisible">. </span>
              </Badge>
            )}
        </div>
      ))}
    </div>
  );
};

export default Sidebar;
